import { render, staticRenderFns } from "./project-questions.vue?vue&type=template&id=d1c9459e&scoped=true"
import script from "./project-questions.vue?vue&type=script&lang=js"
export * from "./project-questions.vue?vue&type=script&lang=js"
import style0 from "./project-questions.vue?vue&type=style&index=0&id=d1c9459e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c9459e",
  null
  
)

export default component.exports